export const FETCH_TRANSACTION_DETAILS = 'FETCH_TRANSACTION_DETAILS';
export const FETCH_TRANSACTION_DETAILS_SUCCESS = 'FETCH_TRANSACTION_DETAILS_SUCCESS';
export const FETCH_TRANSACTION_DETAILS_FAILURE = 'FETCH_TRANSACTION_DETAILS_FAILURE';
export const CLEAR_TRANSACTION_DETAILS = 'CLEAR_TRANSACTION_DETAILS';


export const CREATE_PAYMENT = 'CREATE_PAYMENT';
export const CREATE_PAYMENT_SUCCESS = 'CREATE_PAYMENT_SUCCESS';
export const CREATE_PAYMENT_FAILURE = 'CREATE_PAYMENT_FAILURE';
